import { defineComponent as _defineComponent } from 'vue'
import { pollTailwindClasses, toOzBoxColor } from '@@/bits/post_color'
import type { Poll } from '@@/types'
import { User } from '@@/types'
import { Wish } from '@padlet/arvo'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from 'library/v4/components/OzDivider.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import SurfacePostPollBottomSection from 'vuecomponents/SurfacePostPollBottomSection.vue'
import { storeToRefs } from 'pinia'
import { useSurfacePermissionsStore } from 'pinia/surface_permissions'
import { computed, ref } from 'vue'
import { useSurfacePostsStore } from 'pinia/surface_posts'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostPoll',
  props: {
    poll: null,
    pollCaption: { default: '' },
    post: null,
    user: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    displayMode: { default: 'default' }
  },
  emits: ["dblclick"],
  setup(__props: any) {

const props = __props as { poll: Poll, pollCaption: string, post: Wish, user: User, darkMode: boolean | 'auto', displayMode: 'expanded' | 'default' }





const isExpandedOrSurface = computed(() => props.displayMode === 'expanded')
const pollColors = pollTailwindClasses(isExpandedOrSurface.value ? null : props.post.color)
const { postPollVote } = useSurfacePostsStore()
const { canIModerate } = storeToRefs(useSurfacePermissionsStore())
const isPostAuthor = computed(() => props.post.author_id === props.user.id)
const totalVotesArray = computed(() => {
  return props.poll.poll_choices.map((choice) => choice.total_votes)
})
const totalVotesCount = computed(() => {
  return totalVotesArray.value.reduce((a, b) => a + b, 0)
})
const highestVoteTotal = computed(() => Math.max(...totalVotesArray.value))
const isPollClosed = computed(() => props.poll.closed_at != null)
const pollResults = computed(() => {
  return props.poll.poll_choices.map((pollChoice) => {
    return {
      ...pollChoice,
      percentage: totalVotesCount.value === 0 ? 0 : (pollChoice.total_votes / totalVotesCount.value) * 100,
      pollWinner: pollChoice.total_votes === highestVoteTotal.value && isPollClosed.value,
      userVoted: pollChoice.voter_user_ids[props.user.id],
    }
  })
})

const votedUserIdsByPollChoiceId = computed(() => {
  return props.poll?.poll_choices?.reduce((map, pollChoice) => {
    map[pollChoice.poll_choice_id] = pollChoice.voter_user_ids
    return map
  }, {} as Record<number, Record<number, boolean>>)
})

const didCurrentUserVoteForPoll = computed(() => {
  return Object.entries(votedUserIdsByPollChoiceId.value).some(([, userIds]) => {
    return userIds[props.user.id]
  })
})

const selectedPollChoiceId = ref(-1)
const isShowingPollResults = ref(false)
const isVoting = ref(false)

const togglePollResults = () => {
  isShowingPollResults.value = !isShowingPollResults.value
}

const vote = async () => {
  isVoting.value = true
  await postPollVote({ wishId: props.post.id, pollId: props.poll.poll_id, pollChoiceIds: [selectedPollChoiceId.value] })
  isVoting.value = false
}

return { __sfc: true,props, isExpandedOrSurface, pollColors, postPollVote, canIModerate, isPostAuthor, totalVotesArray, totalVotesCount, highestVoteTotal, isPollClosed, pollResults, votedUserIdsByPollChoiceId, didCurrentUserVoteForPoll, selectedPollChoiceId, isShowingPollResults, isVoting, togglePollResults, vote, toOzBoxColor, OzBox, OzBoxColors, OzDivider, OzDividerColorScheme, OzIcon, SurfacePostPollBottomSection }
}

})